import { API_CONFIG, getUserId } from '@/project/configs/api.js';

class ApiService {
  /**
   * @param {string} endpoint
   * @param {string} method
   * @param {any} body
   */
  async request(endpoint, method = 'GET', body = null) {
    const userId = getUserId();
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
    const url = new URL(`${API_CONFIG.baseURL}/${cleanEndpoint}`);
    url.searchParams.set('userId', userId);
    url.searchParams.set('group', 'ultraxeno');

    const options = {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
    };

    if (body) {
      options['body'] = JSON.stringify(body);
    }

    try {
      const response = await fetch(url.toString(), options);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || data.error?.message || 'API request failed');
      }

      return {
        success: true,
        data: data.result || data.data || data,
      };
    } catch (error) {
      console.error(`API Error (${method} ${endpoint}):`, error);
      return {
        success: false,
        message: error instanceof Error ? error.message : 'Unknown error',
      };
    }
  }

  /** @param {string} endpoint */
  async get(endpoint) {
    return this.request(endpoint, 'GET');
  }

  /** @param {string} endpoint @param {any} body */
  async post(endpoint, body) {
    return this.request(endpoint, 'POST', body);
  }

  /** @param {string} endpoint @param {any} body */
  async put(endpoint, body) {
    return this.request(endpoint, 'PUT', body);
  }

  /** @param {string} endpoint @param {any} body */
  async patch(endpoint, body) {
    return this.request(endpoint, 'PATCH', body);
  }

  /** @param {string} endpoint */
  async delete(endpoint) {
    return this.request(endpoint, 'DELETE');
  }
}

export default new ApiService();
